

// Reference : https://github.com/fakiolinho/react-loading

import React from 'react';
import ReactLoading from 'react-loading';

const Loading = ({type,color,width,height,delay}) => (
	<ReactLoading type={type} color={color} height={height} width={width} delay={delay} />
);

export default Loading;








